import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';

/* ceo_salon_switch_02nov2026 (CEO, Team_And_Sizes_FINAL_1 item 2) —
   "Switch salon" in the menu footer, CEO only, remembered per device.
   Default = Hair 305 London. */

export const CEO_SALON_KEY = 'rvk_ceo_salon';

export const CeoSalonSwitch = ({ dark }) => {
  const { user, token } = useAuth();
  const [salons, setSalons] = useState([]);
  const [cur, setCur] = useState(() => {
    try { return localStorage.getItem(CEO_SALON_KEY) || ''; } catch { return ''; }
  });

  useEffect(() => {
    if (!token || user?.role !== 'founder') return undefined;
    let dead = false;
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bk/salon-list`,
          { headers: { Authorization: `Bearer ${token}` } });
        if (!r.ok) return;
        const d = await r.json();
        if (dead) return;
        setSalons(d.salons || []);
        if (!localStorage.getItem(CEO_SALON_KEY) && d.default_salon_id) {
          localStorage.setItem(CEO_SALON_KEY, d.default_salon_id);
          setCur(d.default_salon_id);
        }
      } catch { /* CEO-only control stays hidden */ }
    })();
    return () => { dead = true; };
  }, [token, user?.role]);

  if (user?.role !== 'founder' || salons.length < 2) return null;

  const pick = (sid) => {
    if (sid === cur) return;
    localStorage.setItem(CEO_SALON_KEY, sid);
    setCur(sid);
    window.location.assign('/dashboard');
  };

  const label = { fontSize: 13, letterSpacing: '.18em', textTransform: 'uppercase',
    fontWeight: 600, color: dark ? '#D9BE8E' : '#7E5F2E', margin: '0 0 6px' };

  return (
    <div data-testid="ceo-salon-switch" style={{ marginBottom: 10 }}>
      <p style={label}>Switch salon</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {salons.map((s) => {
          const on = s.salon_id === cur;
          return (
            <button key={s.salon_id} type="button" onClick={() => pick(s.salon_id)}
              data-testid={`switch-salon-${s.salon_id}`} aria-pressed={on}
              style={{ minHeight: 48, borderRadius: 14, padding: '6px 14px', textAlign: 'left',
                cursor: 'pointer', fontSize: 15, fontWeight: on ? 700 : 500,
                border: on ? '1px solid #B99A65' : `1px solid ${dark ? '#5A4254' : '#DCCFC6'}`,
                background: on ? (dark ? '#D9BE8E' : '#291525') : 'transparent',
                color: on ? (dark ? '#291525' : '#F8F4F1') : (dark ? '#F8F4F1' : '#2B1F27') }}>
              <span style={{ display: 'block' }}>{s.name}</span>
              <span style={{ display: 'block', fontSize: 15, fontWeight: 400, opacity: .75 }}>
                {s.country} · {s.currency}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
